























































import {Component, Prop, Vue} from 'vue-property-decorator'
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";

@Component({
  name: 'ContactsCategory',
  components: {ErrorFetchingData}
})

export default class ContactsCategory extends Vue {
  @Prop({type: String, default: 'Заголовок'}) protected title!: any
  @Prop({
    type: Object, default: () => {
    }
  }) protected category!: any
  @Prop({type: Boolean, default: false}) protected loading!: boolean
  @Prop({type: Boolean, default: false}) protected error!: boolean
  @Prop({type: Boolean, default: false}) protected isPdf!: boolean

  get onePercent() {
    let max = 0
    for (let item in this.category) {
      max += this.category[item].count
    }
    return max / 100
  }

  getColor(itemName: string): string {
    return this.category[itemName].color
  }

  getWidth(itemName: any) {
    if (!this.category.exists.count && !this.category.isNew.count && !this.category.none.count) return '0%'
    return this.category[itemName].count / this.onePercent + '%'
  }
}
